// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fYsdG {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n  .tv2Jo {\n    border: 1px solid #4d5580;\n    font-weight: 500;\n    height: 30px;\n  }\n\n  .Hk\\+p2 {\n    border: 1px solid rgba(157,182,251,0.30196);\n    font-weight: 500;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ViewTag": "fYsdG",
	"ViewTag_selectHierarchyTag": "tv2Jo",
	"ViewTag_tag": "Hk+p2"
};
export default ___CSS_LOADER_EXPORT___;
